module.exports = __webpack_public_path__ + "static/media/kr.60fde7fc.svg";